import styled from 'styled-components/macro';

export const Offscreen = styled.span`
	height: 1px;
	margin: -1px;
	overflow: hidden;
	position: fixed;
	width: 1px;
`;
